import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  cookieDeclarationWillRender: {
    id: 'cookieDeclarationWillRender',
    defaultMessage: 'Cookie declaration will be rendered here',
  },
});
